import React from 'react';
import HomePage from '../components/HomePage';
import MainLayout from '../components/MainLayout';

export default () => {
    return <MainLayout><HomePage/></MainLayout>
}
